import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  Divider,
} from '@mui/material';

const ConfirmActionDialog = ({
  open,
  title,
  onClose,
  onConfirm,
  cancelText,
  confirmText,
  isConfirmDisabled,
  isCancelDisabled,
  maxWidth,
}) => {
  const { t } = useTranslation();

  if (!open) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth={maxWidth}>
      <DialogTitle id="confirm-action-dialog-title">{t(title)}</DialogTitle>
      <Divider />
      <DialogActions>
        <Button
          onClick={onClose}
          color="primary"
          variant="outlined"
          disabled={isCancelDisabled}>
          {t(cancelText)}
        </Button>
        <Button
          onClick={() => {
            onConfirm();
            onClose();
          }}
          color="primary"
          variant="contained"
          disabled={isConfirmDisabled}
          autoFocus>
          {t(confirmText)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmActionDialog.defaultProps = {
  cancelText: 'cancel',
  confirmText: 'remove',
  isConfirmDisabled: false,
  isCancelDisabled: false,
  maxWidth: 'xs',
};

ConfirmActionDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  cancelText: PropTypes.string,
  confirmText: PropTypes.string,
  isConfirmDisabled: PropTypes.bool,
  isCancelDisabled: PropTypes.bool,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
};

export default ConfirmActionDialog;
